import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
// -*- mode: jsx;-*-
import DistrictPartnerTabsController, { getSearchApiURL } from './DistrictPartnerTabsController.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import '../sharebar/shareBarOnClickHandlers.js';


const errorLoading = function () {
    document.getElementById('tabs').innerHTML = '<p class="error">There was a problem loading these projects. Please try again later.</p>';
};

// This is for reference only and not actually enforced. See DistrictPartnerPageController.java for more details.
PropTypes.shape({
    fundedProjects: PropTypes.string,
    districtId: PropTypes.string,
});

$(() => {
    const data = JSON.parse(document.getElementById('js-init-data').textContent);
    const districtId = data.districtId;
    const funded = data.fundedProjects;
    const activeProjectsApiUrl = getSearchApiURL(districtId, false);
    ReactDOM.render(
        <LoadingEllipsis/>,
        document.getElementById('tabs'),
    );
    $.ajax({
        url: activeProjectsApiUrl,
        dataType: 'json',
        success: activeData => {
            ReactDOM.render(
                <DistrictPartnerTabsController
                    districtId={districtId}
                    funded={parseInt(funded)}
                    active={parseInt(activeData.totalProposals)}
                />,
                document.getElementById('tabs'),
            );
        },
        error: errorLoading,
    });
});
